var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefCase = function SvgBriefCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 22 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.526,
    d: "M18.778 4.334H3.222A2.22 2.22 0 0 0 1 6.556v8.89c0 1.226.995 2.221 2.222 2.221h15.556A2.22 2.22 0 0 0 21 15.445V6.556a2.22 2.22 0 0 0-2.222-2.222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.526,
    d: "m8.778 9.889.234.118a4.45 4.45 0 0 0 3.976 0l.234-.118M7.667 3.222A2.22 2.22 0 0 1 9.889 1h2.222a2.22 2.22 0 0 1 2.222 2.222v1.111H7.667z"
  })));
};
export default SvgBriefCase;